import { Box, Autocomplete, Button, Grid, Grid2, IconButton, MenuItem, Menu, ListItemIcon, ListItemText, Paper, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField, Typography, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import TokenError from '../tokenError';
import {
    makeGetRequestToUrl,
    makePostRequestToUrl,
    importCSV,
    parseCSVLine,
    handleImportCSVWithCaseInsensitive,
    processBulkImport
} from '../commonFunc.jsx';
import config from '../../config/config.js';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import { useEffect, useRef, useState } from "react";
import PhoneInput from 'react-phone-number-input';
import { parsePhoneNumber } from 'libphonenumber-js';
import defaultImg from '../../assets/images/defaultimg.png';
import { Label } from "flowbite-react";
import axios from "axios";
import threeDots from '../../assets/images/threeDots.svg';
import BlockImg from '../../assets/images/blockImg.svg';
import deleteImg from '../../assets/images/deleteImg.svg';
import { CSVLink } from "react-csv";
import exportCSVIcon from '../../assets/icons/exportCsvBlack.svg';
import importArrowIcon from '../../assets/images/importArrow.svg';

var constants = require('../../constant');

const Helper = () => {

    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [open, setOpen] = useState(false);

    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [editable, setEditable] = useState(false);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [rows, setRows] = useState([]);
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('helper_id');
    const [page, setPage] = useState(0);
    const [rowsPerPage] = useState(10);
    const [helperName, setHelperName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [countryCode, setCountryCode] = useState('');
    const [truckerId, setTruckerId] = useState('');
    const [healthCardNumber, setHealthCardNumber] = useState('');
    const [helperId, setHelperId] = useState('');
    const [healthCertificate, setHealthCertificate] = useState('');
    const [showTemplateButton, setShowTemplateButton] = useState(false);
    
    const [selectedRow, setSelectedRow] = useState(null);
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [confirmAction, setConfirmAction] = useState('');
    const [actionReason, setActionReason] = useState('');
    const [isReasonError, setIsReasonError] = useState(false);
    const [formErrors, setFormErrors] = useState({
        helperName: false,
        email: false,
        phone: false,
        healthCardNumber: false,
        truckerId: false,
        healthCardImageUrl: false,
        truckVendorId: false
    });
    const [vendorsData, setVendorsData] = useState([]);
    const fileInputRef = useRef(null);

    // Image upload state
    const [healthCardImage, setHealthCardImage] = useState(null);
    const [healthCardImageUrl, setHealthCardImageUrl] = useState("");
    const [allData, setAllData] = useState([]);

    const handleClose = () => {
        setOpen(false);
        setEditable(false);
    }

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    const handleOpenAddHelper = () => {
        setOpen(true);
        setEditable(false);
        setEmail('');
        setHelperName('');
        setPhone('');
        setCountryCode('');
        setHealthCardNumber('');
        setTruckerId('');
        setHealthCardImage(null);
        setHealthCardImageUrl('');
        setFormErrors({
            helperName: false,
            email: false,
            phone: false,
            healthCardNumber: false,
            truckerId: false,
            healthCardImageUrl: false,
            truckVendorId: false
        });
        setEmailError(false);
    }

    const formatDataForCSV = (data) => {
        return data ? (data.map((item) => ({
            ...item
        }))) : '';
    };

    // Define custom headers
    const headers = [
        { label: 'Helper ID', key: 'helper_id' },
        { label: 'Name', key: 'name' },
        { label: 'Email', key: 'email' },
        { label: 'Phone Number', key: 'phone_no' },
        { label: 'Health Card No', key: 'health_card_no' },
        { label: 'Truck Vendor ID', key: 'truck_vendor_id' },
        { label: 'Health Card Image', key: 'health_card_image' }
    ];

    const handleSubmit = async() =>{
        // Validate all required fields
        const errors = {
            helperName: !helperName.trim(),
            email: !email.trim() || emailError,
            phone: !phone,
            healthCardNumber: !healthCardNumber.trim(),
            truckerId: !truckerId,
            healthCardImageUrl: !healthCardImageUrl,
            truckVendorId: !truckerId
        };
        
        // Update error state
        setFormErrors(errors);
        
        // Check if any validation errors exist
        if (Object.values(errors).some(error => error)) {
            setMessage('Please fill in all required fields correctly');
            showSnackbar(true);
            return; // Prevent form submission
        }

        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            city_id: cityFilter,
            name: helperName,
            phone_no: phone,
            email: email,
            health_card_no: healthCardNumber,
            truck_vendor_id: truckerId,
            health_card_image: healthCardImageUrl
        };
        if(editable && helperId!=''){
            payload.helper_id = helperId;
        }

        try {
            const url = operationsUrl + '/transport/add_update_helpers';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                handleClose();
                fetchHelpersData();
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }

        // handleClose();
        // fetchCorporateData();
    }

    const fetchHelpersData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_helpers';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                // Sort data in descending order by helper_id before setting it
                const sortedData = [...response.data].sort((a, b) => {
                    if (a[orderBy] < b[orderBy]) return order === 'asc' ? -1 : 1;
                    if (a[orderBy] > b[orderBy]) return order === 'asc' ? 1 : -1;
                    return 0;
                });
                setRows(sortedData);
                const formattedData = formatDataForCSV(sortedData);
                setAllData(formattedData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    const fetchVendorsData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_truck_vendors';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setVendorsData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        fetchHelpersData();
        fetchVendorsData();
    },[cityFilter])

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false);
        setShowTemplateButton(false);
    };

    const handleOpenEditHelper = (row) => {
        setEditable(true);
        setHelperName(row.name);
        setHelperId(row.helper_id);
        setPhone(row.phone_no);
        setEmail(row.email);
        // setCountryCode(row.country_code);
        setHealthCardNumber(row.health_card_no);
        setHealthCardImageUrl(row.health_card_image);
        // setHealthCardImage(row.health_card_image);
        setTruckerId(row.truck_vendor_id);
        setFormErrors({
            helperName: false,
            email: false,
            phone: false,
            healthCardNumber: false,
            truckerId: false,
            healthCardImageUrl: false,
            truckVendorId: false
        });
        setEmailError(false);
        setTimeout(() => {
            setOpen(true);
        }, 0);
    }

    // Image upload handler
    const handleHealthCardImageChange = async(e) => {
        const file = e.target.files[0];
        if (file) {
            // setHealthCardImageUrl(URL.createObjectURL(file));
            const formData = new FormData();
            formData.append('image', file);
    
            try {
                const response = await axios.post(operationsUrl + '/upload_image', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
    
                const s3Url = response.data.url;
                const newImage = {
                    name: file.name,
                    src: s3Url,
                    isUploaded: true,
                };
                setHealthCardImageUrl(s3Url);
                setHealthCardImage(file);
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        }
    };

    // Email validation functions
    const validateEmail = (value) => {
        const re = /^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@\"]+\.)+[^<>()[\]\\.,;:\s@\"]{2,})$/i;
        return re.test(String(value).toLowerCase());
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        setEmailError(value.length > 0 && !validateEmail(value));
    };

    // Menu handlers
    const handleMenuOpen = (event, row) => {
        setMenuAnchorEl(event.currentTarget);
        setSelectedRow(row);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };

    const openConfirmDialog = (action, row) => {
        handleMenuClose();
        setConfirmAction(action);
        setSelectedRow(row);
        setActionReason('');
        setIsReasonError(false);
        setConfirmDialogOpen(true);
    };

    const handleConfirmClose = () => {
        setConfirmDialogOpen(false);
        setActionReason('');
        setIsReasonError(false);
    };

    const handleConfirmAction = async () => {
        // Validate reason is provided
        if (!actionReason.trim()) {
            setIsReasonError(true);
            return;
        }

        try {
            const token = localStorage.getItem('token');
            const payload = {
                token: token,
                helper_id: selectedRow.helper_id,
                reason: actionReason
            };
            if (confirmAction === 'block') {
                payload.status = 2;
            } else if (confirmAction === 'unblock') {
                payload.status = 1;
            } else if (confirmAction === 'delete') {
                payload.status = 3;
            }
            let url = operationsUrl + '/transport/add_update_helpers';
            
            const response = await makePostRequestToUrl(url, payload);
            
            if (response.flag === 200) {
                setMessage(response.message);
                showSnackbar(true);
                fetchHelpersData(); // Refresh the list
            } else {
                setMessage(response.message || `Failed to ${confirmAction} helper`);
                showSnackbar(true);
            }
        } catch (error) {
            console.error(`Error ${confirmAction}ing helper:`, error);
            setMessage(`An error occurred while ${confirmAction}ing the helper`);
            showSnackbar(true);
        } finally {
            handleConfirmClose();
        }
    };

    const handleReasonChange = (e) => {
        setActionReason(e.target.value);
        if (e.target.value.trim()) {
            setIsReasonError(false);
        }
    };

    //import CSV
    const requiredColumns = ['name', 'email', 'phone_no','health_card_no', 'health_card_image', 'truck_vendor_id'];
    
    const alternativeColumns = {
        'name': ['Name', 'name', 'NAME', 'Name'],
        'email': ['Email', 'email', 'EMAIL', 'Email'],
        'phone_no': ['Phone No', 'phone_no', 'PHONE_NO', 'Phone_No', 'Phone Number'],
        'health_card_no': ['Health Card No', 'health_card_no', 'HEALTH_CARD_NO', 'Health_Card_No'],
        'health_card_image': ['Health Card Image', 'health_card_image', 'HEALTH_CARD_IMAGE', 'Health_Card_Image'],
        'truck_vendor_id': ['Truck Vendor ID', 'truck_vendor_id', 'TRUCK_VENDOR_ID', 'Truck_Vendor_Id', 'Trucker ID']
    };
    
    // Generate template data for CSV download
    const generateTemplateData = () => {
        // Create header row using the first alternative column name for each required column
        const headers = requiredColumns.map(col => alternativeColumns[col] ? alternativeColumns[col][0] : col);
        
        // Create an empty row example
        const emptyRow = {};
        requiredColumns.forEach(col => {
            emptyRow[alternativeColumns[col] ? alternativeColumns[col][0] : col] = '';
        });
        
        return [headers.reduce((obj, header, index) => {
            obj[header] = '';
            return obj;
        }, {})];
    };
    
    // Template CSV headers for download
    // Function to download template CSV file
    const downloadCSVTemplate = () => {
        // Use the required columns with example data
        const headers = requiredColumns.map(col => alternativeColumns[col] ? alternativeColumns[col][0] : col);
        const exampleRow = ['Helper Name', 'helper@example.com', '9876543210', 'HC12345', 'http://example.com/health-card-image.jpg', '1'];
        const csvContent = headers.join(',') + '\n' + exampleRow.join(',');
        
        // Create a blob and download
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Helpers_Template.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    
    const templateHeaders = requiredColumns.map(col => ({
        label: alternativeColumns[col] ? alternativeColumns[col][0] : col,
        key: alternativeColumns[col] ? alternativeColumns[col][0] : col
    }));

    // Handle CSV import
    const handleImportCSV = (event) => {
        const file = event.target.files[0];
        if (!file) {
            setMessage('No file selected');
            showSnackbar(true);
            return;
        }
        
        console.log('File selected for import:', file.name, 'Size:', file.size, 'Type:', file.type);
        
        // Use the imported handleImportCSVWithCaseInsensitive function
        handleImportCSVWithCaseInsensitive(
            file,
            // Success callback
            async (data, headers) => {
                try {
                    if (!data || data.length === 0) {
                        setMessage('CSV file contains no data');
                        showSnackbar(true);
                        return;
                    }
                    
                    // Process the import using the new shared function
                    const result = await processLocationImport(data);
                    
                    // Display result message
                    setMessage(result.message);
                    showSnackbar(true);
                    
                    // Refresh data if successful
                    if (result.success) {
                        fetchHelpersData();
                    }
                    
                    // Reset file input
                    event.target.value = '';
                } catch (error) {
                    console.error('Error processing imported data:', error);
                    setMessage('Error processing imported data');
                    showSnackbar(true);
                    event.target.value = '';
                }
            },
            // Error callback
            (error) => {
                console.error('CSV import error:', error);
                let errorMessage = 'Error importing CSV file';
                
                // If we have specific missing columns info
                if (error.missingColumns) {
                    errorMessage = `CSV is missing required columns: ${error.missingColumns.join(', ')}`;
                    // Show template download button in snackbar
                    setShowTemplateButton(true);
                } else if (typeof error === 'string') {
                    errorMessage = error;
                    setShowTemplateButton(false);
                } else if (error.message) {
                    errorMessage = error.message;
                    setShowTemplateButton(false);
                }
                
                setMessage(errorMessage);
                showSnackbar(true);
                event.target.value = '';
            },
            requiredColumns,
            alternativeColumns
        );
    };
    
    // Process imported location data using the shared processBulkImport function
    const processLocationImport = async (data) => {
        const token = localStorage.getItem('token');
        const url = operationsUrl + '/transport/add_bulk_helpers';
        
        // Map function to convert CSV data to the expected API format
        const mapLocationData = (item) => {
            // Create location object from CSV data
            const locationData = {
                city_id: cityFilter,
                name: item.name || item['Name'] || '',
                email: item.email || item['Email'] || '',
                phone_no: item.phone_no || item['Phone No'] || '',
                health_card_no: item.health_card_no || item['Health Card No'] || '',
                health_card_image: item.health_card_image || item['Health Card Image'] || '',
                truck_vendor_id: item.truck_vendor_id || item['Truck Vendor ID'] || '',
            };
            
            // Return null for invalid entries (will be filtered out)
            if (!locationData.name || !locationData.email || !locationData.phone_no || !locationData.health_card_no || !locationData.health_card_image || !locationData.truck_vendor_id) {
                console.warn('Skipping invalid client:', item);
                return null;
            }
            
            return locationData;
        };
        
        // Use the shared processBulkImport function
        return await processBulkImport(data, token, url, 'helpers', mapLocationData);
    };

    return(
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Helpers
            </Typography>

            <Grid2 container spacing={2} alignItems="center" style={{ marginTop: '2%', marginBottom: '3%' }}>
                <Grid2 item>
                <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>
                <Grid2 item>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddHelper}
                        style={{
                            width: '185px',
                            height: '50px',
                            backgroundColor: '#000000',
                            textTransform: 'none',
                            borderRadius: '8px',
                        }}
                    >
                        + Add Helpers
                    </Button>
                </Grid2>
                <Grid2 item sx={{ marginLeft: "auto", display: 'flex', alignItems: 'center', gap: 2 }}>
                    <input
                        type="file"
                        accept=".csv"
                        ref={fileInputRef}
                        onChange={handleImportCSV}
                        style={{ display: 'none' }}
                    />
                    <Button
                        variant="outlined"
                        onClick={() => downloadCSVTemplate()}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1.5px solid #111',
                            background: '#fff',
                            color: '#111',
                            borderRadius: '14px',
                            minWidth: '180px',
                            height: '48px',
                            fontWeight: 500,
                            fontSize: '22px',
                            textTransform: 'none',
                            boxShadow: 'none',
                            transition: 'background 0.2s',
                            '&:hover': {
                                background: '#f9f9f9',
                                borderColor: '#111',
                                color: '#111',
                                boxShadow: 'none',
                            },
                        }}
                    >
                        <img src={importArrowIcon} alt="Import CSV" style={{ width: 20, height: 20, marginRight: 8, marginTop: 2 }} />
                        <span style={{ fontWeight: 500, fontSize: 16 }}>Sample CSV</span>
                    </Button>

                    <Button
                        variant="outlined"
                        onClick={() => fileInputRef.current.click()}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1.5px solid #111',
                            background: '#fff',
                            color: '#111',
                            borderRadius: '14px',
                            minWidth: '180px',
                            height: '48px',
                            fontWeight: 500,
                            fontSize: '22px',
                            textTransform: 'none',
                            boxShadow: 'none',
                            transition: 'background 0.2s',
                            '&:hover': {
                                background: '#f9f9f9',
                                borderColor: '#111',
                                color: '#111',
                                boxShadow: 'none',
                            },
                        }}
                    >
                        <img src={importArrowIcon} alt="Import CSV" style={{ width: 20, height: 20, marginRight: 8, marginTop: 2 }} />
                        <span style={{ fontWeight: 500, fontSize: 16 }}>Import CSV</span>
                    </Button>

                    <Button
                        variant="outlined"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1.5px solid #111',
                            background: '#fff',
                            color: '#111',
                            borderRadius: '14px',
                            minWidth: '180px',
                            height: '48px',
                            fontWeight: 500,
                            fontSize: '22px',
                            textTransform: 'none',
                            boxShadow: 'none',
                            transition: 'background 0.2s',
                            '&:hover': {
                                background: '#f9f9f9',
                                borderColor: '#111',
                                color: '#111',
                                boxShadow: 'none',
                            },
                        }}
                    >
                        <CSVLink
                            data={allData}
                            headers={headers}
                            filename={"Helpers Data.csv"}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                                textDecoration: 'none',
                                color: 'inherit',
                                width: '100%',
                                justifyContent: 'center',
                            }}
                        >
                            <span style={{ fontWeight: 500, fontSize: 16 }}>Export CSV</span>
                            <img src={exportCSVIcon} alt="Export CSV" style={{ width: 18, height: 18, marginLeft: 4, marginTop: 2 }} />
                        </CSVLink>
                    </Button>
                </Grid2>
            </Grid2>

            {open && (
                <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Paper elevation={3}
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
                                    {editable ? 'Edit Helper' : 'Add Helper'}
                                </Typography>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12}>
                                        <Label style={{color:'#1A1E25', fontSize:'16px'}}>Helper Name<span style={{ color: 'red' }}>*</span></Label>
                                        {formErrors.helperName && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Helper Name is required</Typography>}
                                        <TextField sx={{marginTop:'1%'}} placeholder="Helper Name" fullWidth variant="outlined" type="text"
                                            value={helperName} 
                                            onChange={(e) => {
                                                setHelperName(e.target.value);
                                                setFormErrors({...formErrors, helperName: !e.target.value.trim()});
                                            }}
                                            error={formErrors.helperName}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {
                                                    height: '52px',
                                                    borderRadius:'12px',
                                                    fontSize: '16px',
                                                    padding: '8px 14px',
                                                    backgroundColor: '#FFFFFF',
                                                },
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12} sx={{borderRadius:'12px', border:'1px solid #D1D5DB', padding:'4px', marginTop:'16px', marginLeft:'8px'}}>
                                        <Grid2 sx={{backgroundColor:'#F9F9F9', borderRadius:'8px', padding:'8px'}}>
                                            Health Card Certificate<span style={{ color: 'red' }}>*</span>
                                        </Grid2>
                                        <Grid2 container size={12} sx={{marginTop:'12px'}}>
                                            <Grid2 size={3} sx={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
                                                {healthCardImageUrl ? (
                                                    <img src={healthCardImageUrl} alt="Health Card" height="100px" width="100px" style={{objectFit:'cover', borderRadius:'6px', border:'1px solid #ddd'}} />
                                                ) : (
                                                    <img src={defaultImg} alt="img" height="100px" width="100px" style={{objectFit:'cover', borderRadius:'6px', border:'1px solid #ddd'}} />
                                                )}
                                                
                                            </Grid2>
                                            <Grid2 size={9}>
                                                <Typography style={{color: formErrors.healthCardNumber ? '#d32f2f' : 'inherit'}}>Health Card Number<span style={{ color: 'red' }}>*</span></Typography>
                                                {formErrors.healthCardNumber && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Health Card Number is required</Typography>}
                                                <TextField sx={{marginTop:'1%'}} placeholder="Health Card Number" fullWidth variant="outlined" type="text"
                                                    value={healthCardNumber} 
                                                    onChange={(e) => {
                                                        setHealthCardNumber(e.target.value);
                                                        setFormErrors({...formErrors, healthCardNumber: !e.target.value.trim()});
                                                    }}
                                                    error={formErrors.healthCardNumber} 
                                                    InputProps={{
                                                        inputProps: { min: 0 }, // Prevent values less than zero
                                                        style: {
                                                            height: '46px',
                                                            borderRadius:'12px',
                                                            fontSize: '16px',
                                                            padding: '8px 14px',
                                                            backgroundColor: '#FFFFFF',
                                                        },
                                                    }}
                                                />
                                                <Button
                                                    variant="contained"
                                                    component="label" fullWidth
                                                    size="small"
                                                    sx={{marginTop:'8px', fontSize:'12px', borderRadius:'6px', border: '1px dotted #9CA2AA', backgroundColor:'#F9F9F9', marginBottom:'12px'}}
                                                >
                                                    <Typography sx={{color:'#6B6F74', textTransform:'none', fontSize:'12px'}}>Click here to upload</Typography>
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        hidden
                                                        onChange={handleHealthCardImageChange}
                                                    />
                                                </Button>
                                            </Grid2>
                                        </Grid2>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Email<span style={{ color: 'red' }}>*</span></Label>
                                    <TextField sx={{marginTop:'1%'}} placeholder="Email" fullWidth variant="outlined" type="email"
                                        value={email} 
                                        onChange={(e) => {
                                            handleEmailChange(e);
                                            setFormErrors({...formErrors, email: !e.target.value.trim() || emailError});
                                        }}
                                        error={emailError || formErrors.email}
                                        helperText={emailError ? "Please enter a valid email address" : formErrors.email ? "Email is required" : ""}
                                        InputProps={{
                                            inputProps: { min: 0 }, // Prevent values less than zero
                                            style: {
                                                height: '52px',
                                                borderRadius:'12px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                            },
                                        }}
                                    />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <Label style={{color:'#1A1E25', fontSize:'16px'}}>Mobile Number<span style={{ color: 'red' }}>*</span></Label>
                                        <div style={{width:'100%', marginTop:'1%', border: formErrors.phone ? '1px solid #d32f2f' : '1px solid rgba(0, 0, 0, 0.12)', borderRadius:'12px', backgroundColor:'white'}}>
                                            <PhoneInput
                                                defaultCountry="IN"
                                                value={phone}
                                                onChange={(value) => {
                                                    setPhone(value);
                                                    setFormErrors({...formErrors, phone: !value});
                                                    try {
                                                        const parsed = parsePhoneNumber(value);
                                                        if (parsed) {
                                                            setCountryCode(parsed.countryCallingCode ? `+${parsed.countryCallingCode}` : '');
                                                        }
                                                    } catch (err) {
                                                        console.error('Invalid phone number:', err);
                                                        setCountryCode('');
                                                    }
                                                }}
                                            placeholder="Enter phone number"
                                            style={{
                                                height: '44px',
                                                fontSize: '16px',
                                                alignItems: 'normal', marginTop:'2%'
                                            }}
                                        />
                                        </div>
                                        {formErrors.phone && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Mobile Number is required</Typography>}
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Label style={{color:'#1A1E25', fontSize:'16px'}}>Truck Vendor<span style={{ color: 'red' }}>*</span></Label>
                                        <Select sx={{marginTop:'2%'}}
                                            value={truckerId} 
                                            fullWidth
                                            onChange={(e) => {
                                                setTruckerId(e.target.value);
                                                setFormErrors({...formErrors, truckVendorId: !e.target.value});
                                            }}
                                            style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF', border: formErrors.truckVendorId ? '1px solid #d32f2f' : '1px solid rgba(0, 0, 0, 0.12)'}}>
                                            <MenuItem key="0" value="0">None</MenuItem>
                                            {vendorsData && vendorsData.map((vendor) => (
                                                <MenuItem key={vendor.truck_vendor_id} value={vendor.truck_vendor_id}>
                                                    {vendor.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {formErrors.truckerId && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Truck Vendor is required</Typography>}
                                    </Grid>
                                </Grid>

                                <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px', marginBottom:'8%' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSubmit}
                                        sx={{width: '140px',height: '50px',textTransform: 'none',
                                            fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                        {editable ? 'Update' : 'Save'}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={handleClose}
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            textTransform: 'none',
                                            fontSize: '16px',
                                            backgroundColor: '#F0F0F0',
                                            color: '#B0B0B0',
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </Paper>

                        </div>
                    </Box>
                </div>
            )}

            <TableContainer className="table-container">
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'helper_id'}
                                    direction={orderBy === 'helper_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('helper_id')}
                                >
                                    Helper ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'name'}
                                    direction={orderBy === 'name' ? order : 'asc'}
                                    onClick={() => handleRequestSort('name')}
                                >
                                    Name
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'phone_no'}
                                    direction={orderBy === 'phone_no' ? order : 'asc'}
                                    onClick={() => handleRequestSort('phone_no')}
                                >
                                    Phone
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel
                                    active={orderBy === 'email'}
                                    direction={orderBy === 'email' ? order : 'asc'}
                                    onClick={() => handleRequestSort('email')}
                                >
                                    Email
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {(rowsPerPage > 0
                            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : rows
                        ).map((row) => (
                            <TableRow key={row.helper_id}>
                                <TableCell>{row.helper_id}</TableCell>
                                <TableCell>{row.name}</TableCell>
                                <TableCell>{row.phone_no}</TableCell>
                                <TableCell>{row.email}</TableCell>
                                <TableCell>
                                    <Button
                                        variant="contained"
                                        onClick={() => handleOpenEditHelper(row)}
                                        sx={{
                                            backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                            borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px",
                                            '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                            '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                        }}>
                                        
                                        <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.84304 9.45074L5.39054 6.89324C5.47025 6.53784 5.64979 6.21258 5.90804 5.95574L10.9105 0.998238C11.4178 0.481469 12.1066 0.182825 12.8305 0.165738C13.3765 0.157914 13.9031 0.368518 14.293 0.750738C15.1452 1.75759 15.0352 3.26115 14.0455 4.13324L9.04304 9.13574C8.7862 9.39399 8.46095 9.57353 8.10554 9.65324L5.54804 10.2007H5.40554C5.21858 10.2079 5.04 10.1228 4.92774 9.97316C4.81547 9.82347 4.78382 9.62822 4.84304 9.45074ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor"/>
                                            <path d="M13.933 6.19574C13.6241 6.19978 13.3746 6.44927 13.3705 6.75824V11.0257C13.3806 11.6289 13.148 12.2109 12.7249 12.641C12.3019 13.0711 11.7238 13.3133 11.1205 13.3132H3.97305C2.72607 13.2888 1.72688 12.2729 1.72305 11.0257V3.90824C1.74352 2.65955 2.7617 1.65807 4.01055 1.65824H8.27805C8.58871 1.65824 8.84055 1.4064 8.84055 1.09574C8.84055 0.785078 8.58871 0.533238 8.27805 0.533238H3.97305C2.10292 0.533125 0.581098 2.03823 0.560547 3.90824V11.0257C0.560547 12.9104 2.08838 14.4382 3.97305 14.4382H11.0905C12.9723 14.4341 14.4956 12.9075 14.4955 11.0257V6.75824C14.4915 6.44927 14.242 6.19978 13.933 6.19574Z" fill="currentColor"/>
                                        </svg>
                                    </Button>

                                    <IconButton 
                                        aria-label="more options" 
                                        size="small"
                                        onClick={(e) => handleMenuOpen(e, row)}
                                        sx={{ marginLeft: '4px' }}
                                    >
                                        <img src={threeDots} alt="threeDots"/>
                                    </IconButton>
                                    
                                    <Menu
                                        anchorEl={menuAnchorEl}
                                        open={Boolean(menuAnchorEl) && selectedRow?.helper_id === row.helper_id}
                                        onClose={handleMenuClose}
                                        PaperProps={{
                                            elevation: 3,
                                            sx: {
                                                borderRadius: '8px',
                                                minWidth: '160px',
                                                padding: '4px 0',
                                                overflow: 'visible',
                                                '&:before': {
                                                    content: '""',
                                                    display: 'block',
                                                    position: 'absolute',
                                                    top: 0,
                                                    right: 14,
                                                    width: 10,
                                                    height: 10,
                                                    bgcolor: 'background.paper',
                                                    transform: 'translateY(-50%) rotate(45deg)',
                                                    zIndex: 0,
                                                },
                                            },
                                        }}
                                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                    >
                                        <MenuItem onClick={() => openConfirmDialog(row.status === 2 ? 'unblock' : 'block', row)} sx={{ py: 1 }}>
                                            <ListItemText primary={row.status === 2 ? "Unblock" : "Block"} sx={{ color: '#6B7280' }} />
                                            <ListItemIcon>
                                                <img src={BlockImg} alt="block"/>
                                            </ListItemIcon>
                                        </MenuItem>
                                        <MenuItem onClick={() => openConfirmDialog('delete', row)} sx={{ py: 1 }}>
                                            <ListItemText primary="Delete" sx={{ color: '#6B7280' }} />
                                            <ListItemIcon>
                                                <img src={deleteImg} alt="delete"/>
                                            </ListItemIcon>
                                        </MenuItem>
                                    </Menu>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                        <button
                            onClick={() => handleChangePage(null, page - 1)}
                            disabled={page === 0}
                            className="pagination-arrow"
                        >
                            <img src={prevIcon} alt="Previous" />
                        </button>
                        <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button key={index} onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${page === index ? 'active' : ''}`}>
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            <Snackbar 
                open={snackbar} 
                autoHideDuration={showTemplateButton ? 6000 : 2000} 
                onClose={handleSnackbarClose} 
                message={message}
                action={showTemplateButton && (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <CSVLink
                            data={generateTemplateData()}
                            headers={templateHeaders}
                            filename="helper_template.csv"
                            className="download-template-btn"
                            style={{
                                textDecoration: 'none',
                                marginRight: '8px'
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                sx={{
                                    backgroundColor: '#3B82F6',
                                    color: 'white',
                                    '&:hover': {
                                        backgroundColor: '#2563EB',
                                    },
                                    textTransform: 'none',
                                    fontSize: '12px',
                                    minWidth: 'auto',
                                    borderRadius: '4px',
                                    padding: '4px 8px'
                                }}
                            >
                                Download Template
                            </Button>
                        </CSVLink>
                        <IconButton
                            size="small"
                            aria-label="close"
                            color="inherit"
                            onClick={handleSnackbarClose}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Box>
                )}
            />

            {/* Confirmation Dialog for Block/Delete */}
            <Dialog
                open={confirmDialogOpen}
                onClose={handleConfirmClose}
                aria-labelledby="confirm-dialog-title"
                aria-describedby="confirm-dialog-description"
                PaperProps={{
                    sx: {
                        borderRadius: '12px',
                        padding: '8px',
                        maxWidth: '500px',
                        width: '100%'
                    }
                }}
            >
                <DialogTitle id="confirm-dialog-title" sx={{ fontWeight: '600', fontSize: '20px' }}>
                    {confirmAction === 'block' ? 'Block Helper' : 
                     confirmAction === 'unblock' ? 'Unblock Helper' : 'Delete Helper'}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="confirm-dialog-description" sx={{ color: '#4B5563', mb: 2 }}>
                        Are you sure you want to {confirmAction} this helper? Please provide a reason.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        label="Reason"
                        type="text"
                        fullWidth
                        value={actionReason}
                        onChange={handleReasonChange}
                        error={isReasonError}
                        helperText={isReasonError ? "Please provide a reason" : ""}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                            }
                        }}
                        multiline
                        rows={3}
                    />
                </DialogContent>
                <DialogActions sx={{ padding: '16px' }}>
                    <Button 
                        onClick={handleConfirmClose} 
                        sx={{ 
                            textTransform: 'none', 
                            backgroundColor: '#F0F0F0', 
                            color: '#6B7280',
                            borderRadius: '8px',
                            padding: '8px 16px',
                            '&:hover': { backgroundColor: '#E0E0E0' }
                        }}
                    >
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleConfirmAction} 
                        autoFocus
                        sx={{ 
                            textTransform: 'none', 
                            backgroundColor: confirmAction === 'delete' ? '#EF4444' : 
                                             confirmAction === 'block' ? '#F59E0B' : '#22C55E',
                            color: 'white',
                            borderRadius: '8px',
                            padding: '8px 16px',
                            '&:hover': { 
                                backgroundColor: confirmAction === 'delete' ? '#DC2626' : 
                                                 confirmAction === 'block' ? '#D97706' : '#16A34A'
                            }
                        }}
                    >
                        {confirmAction === 'block' ? 'Block' : 
                         confirmAction === 'unblock' ? 'Unblock' : 'Delete'}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default Helper;